// extracted by mini-css-extract-plugin
module.exports = {"carousel":"RecipeCarousel_carousel__PfJ_W","image":"RecipeCarousel_image___QRYe"};